var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMgpris = function SvgMgpris(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 92 18",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.7316 3.62139v-3.62139h-15.3742l-6.39839 6.39482-6.39848-6.39482h-2.56053v17.9181h3.6223v-11.73696l5.33671 5.33446 5.33669-5.33446v10.66826l.0028 1.0687h16.4331v-10.87922h-3.622v7.25692h-9.1894v-10.67441z",
    fill: "#0500a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.8916 17.9995h1.631v-17.9741094h-1.631z",
    fill: "#dd7567"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0500a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.9287 16.8344h2.8471v-5.4074h3.2003c2.9354 0 4.988-2.1188 4.988-5.16457 0-3.04578-2.0526-5.09837-4.988-5.09837h-6.0474zm2.8471-7.87933v-5.34114h2.7148c1.6111 0 2.5823 1.03733 2.5823 2.6485 0 1.63324-.9712 2.69264-2.6265 2.69264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.4858 16.8344h2.8471v-5.8488h2.7368l3.112 5.8488h3.1782l-3.2223-5.8488c-.309-.5518-.5297-.7725-.5297-.7725v-.0441c1.6553-.66216 2.6485-2.40575 2.6485-4.28178 0-2.07466-.9932-3.57547-2.5602-4.28174-.6842-.30899-1.4567-.44142-3.1562-.44142h-5.0542zm2.8471-8.32074v-4.89973h2.163c2.2291 0 2.8692.92697 2.8692 2.42779 0 1.56703-.9491 2.47194-2.4719 2.47194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.0129 16.8344h2.8471v-15.67034h-2.8471z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.6321 14.9585s1.9202 2.1409 5.4074 2.1409c3.2664 0 5.1645-2.0967 5.1645-4.5907 0-5.0101-7.3716-4.32591-7.3716-7.10683 0-1.10355 1.0373-1.87603 2.3615-1.87603 1.9644 0 3.4652 1.3684 3.4652 1.3684l1.2359-2.31744s-1.5891-1.677386-4.679-1.677386c-3.0016 0-5.2528 1.942236-5.2528 4.546596 0 4.81139 7.3937 4.32588 7.3937 7.12889 0 1.2801-1.0815 1.8981-2.2733 1.8981-2.2071 0-3.9065-1.6553-3.9065-1.6553z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMgpris);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mgpris.8e91de9f4b88f741f23aea5c7ef53886.svg";